import { useCategories, useAreas } from '@ilteducation/content-ref-data';
import { Video } from '@ilteducation/videos';
import { configHelper } from '@ilteducation/config';
import type { ArticleV1 } from '@ilteducation/content-registry-types';

export function useContentHref() {
  const { byId: getCategoryById } = useCategories();
  const { byId: getAreaById } = useAreas();
  const { getAppUrl } = configHelper;

  const getArticleHref = (article: ArticleV1): string => {
    const articlesUrl = getAppUrl('artiklar.begreppa');
    return `${articlesUrl}/view/${article.id}`;
  };

  const getVideoHref = (video: Video, categoryId?: string): string | null => {
    const subject =
      (video?.categories ?? [])
        .filter((id) => (categoryId ? id === categoryId : true))
        .map((id: any) => getCategoryById.value(id))
        .find((c: any) => c && c.kind === 'subject') || null;

    const area =
      (video?.orderedAreas ?? [])
        .map((a: any) => getAreaById.value(a?.id ?? a))
        .find((a: any) => subject && a && a.categoryId === subject.id) || null;

    if (subject && area) {
      return `/videos/${subject.slug}/${area.slug}/${video.slug}`;
    }
    return null;
  };

  const getContentHref = (content: Video | ArticleV1): string | null => {
    switch (content.type) {
      case 'ArticleV1':
        return getArticleHref(content);
      case 'VideoV1':
        return getVideoHref(content);
      default:
        return null;
    }
  };

  return { getVideoHref, getArticleHref, getContentHref };
}
